import Seo from '@/components/feature/Seo';
import { SITE_URL, SITE_DESCRIPTION, SITE_KEYWORDS } from '@/utils/site';
import Hero from './components/Hero';
import FeaturedSection from './components/FeaturedSection';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';
import RecommendSection from './components/RecommendSection';
import FaqSection from './components/FaqSection';
import AboutTeaser from './components/AboutTeaser';
import { heroBanner } from '@/mocks/manga';

export default function HomePage() {
  return (
    <>
      <Seo
        title="073漫画网-健身教练漫画免费阅读下拉式|热血都市漫画大全"
        description={SITE_DESCRIPTION}
        keywords={SITE_KEYWORDS}
        canonicalPath="/"
        image={heroBanner}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            name: '073漫画网热门漫画',
            url: `${SITE_URL}/`,
            itemListElement: [],
          },
        ]}
      />
      <Hero />
      <FeaturedSection />
      <CategoryNav />
      <LatestUpdates />
      <RankingSection />
      <RecommendSection />
      <AboutTeaser />
      <FaqSection />
    </>
  );
}